<template>
  <div style="width: 100%; min-height: 100vh; background: #ffffff">
    <van-nav-bar style="position: fixed; top: 0; left: 0; width: 100%; background: url(/img/counter/top-bg.webp) no-repeat rgb(8, 76, 203);" :title="$t('Transaction Record')" left-arrow @click-left="$router.back()" />
    <div style="height: 46px"></div>
    <div style="width: 100%; min-width: 250px; margin: 0 auto; background: #f4f4f4; box-sizing: border-box; padding: 10px; min-height: 100vh">
      <!-- 筛选条件 -->
      <div class="saibox" ref="saibox">
        <div class="sai" @click="toggleDropdown('type')">
          <span class="truncate-text">{{ typeName[type] }}</span>
          <span class="arrow-down" :class="{ 'active': dropdownType === 'type' }"></span>
        </div>
        <div class="sai" @click="toggleDropdown('date')">
          <span class="truncate-text">{{ dateName[date] }}</span>
          <span class="arrow-down" :class="{ 'active': dropdownType === 'date' }"></span>
        </div> 
      </div>
      
      <!-- 下拉滚动选择框 -->
      <div class="dropdown-container" v-if="dropdownType">
        <div class="dropdown-content" @click.stop>
          <div class="dropdown-grid" v-if="dropdownType === 'type'">
            <div class="dropdown-grid-item" v-for="(item, index) in typeName" :key="index" @click="selectType(index)">
              <div :class="{ 'active': type === index }">{{ item }}</div>
            </div>
          </div>
          <div class="dropdown-grid" v-else-if="dropdownType === 'date'">
            <div class="dropdown-grid-item" v-for="(item, index) in dateName" :key="index" v-if="index > 0" @click="selectDate(index)">
              <div :class="{ 'active': date === index }">{{ item }}</div>
            </div>
          </div>
        </div>
      </div>
      
      <van-list style="margin-top: 10px; padding-bottom: 120px" :finished-text="$t('No more data')" offset="300" v-model="loading" :finished="!!pageData.total && list.length >= pageData.total" @load="getData" v-if="list.length > 0">
        <van-cell
          v-for="(item, index) in list"
          :key="index"
          :is-link="canOpenDetail(item)"
          @click="openDetail(item)"
        >
          <div style="font-size: 0.3rem" v-if="item.out_trade_no && (type == 0 || type == 1 || type == 2 || item.biz_type === 'recharge' || item.biz_type === 'withdraw')">
            {{ $t('Order No:') }}{{ item.out_trade_no }}
            <span v-if="item.biz_type === 'recharge'" style="margin-left: 6px; color: #07c160; font-size: 0.24rem;">充值</span>
            <span v-else-if="item.biz_type === 'withdraw'" style="margin-left: 6px; color: #ee0a24; font-size: 0.24rem;">提现</span>
          </div>
          <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 4px;">
            <div style="font-size: 0.3rem; flex: 1;">{{ $t('Amount:') }}{{ item.amount }}</div>
            <div style="font-size: 0.28rem; flex: 1; text-align: center; color: #666;">{{ item.pay_way }}</div>
            <div style="font-size: 0.28rem; flex: 1; text-align: right; color: #1890ff;">{{ stateText(item) }}</div>
          </div>
          <div
            v-if="showRefuseReason(item)"
            style="font-size: 0.26rem; color: #ee0a24; margin-top: 6px; line-height: 1.5; background: #fff1f0; padding: 6px 8px; border-radius: 4px;"
          >
            拒绝原因：{{ refuseReasonText(item) }}
          </div>
          <div style="font-size: 0.28rem; color: #999; margin-top: 4px;">{{ item.created_at }}</div>
        </van-cell>
      </van-list>
      <div v-else style="margin-top: 60px; text-align: center">
        <img src="/static/image/mescroll-empty.png" style="width: 35%" alt="" />
        <van-divider dashed :style="{ color: '#ccc', borderColor: '#ccc', padding: '20px ' }">{{ $t('No Data') }}</van-divider>
      </div>
    </div>
    <!-- 平台选择弹出层 -->
    <van-popup v-model="popup" position="bottom" :style="{ height: 'auto', maxHeight: 'calc(100% - 46px)' }">
      <div class="lisg">
        <div class="bs" v-for="(item, index) in dogameLis" :key="index" @click="changDogame(item.name, item.platname)">
          <div :class="api_type == item.platname ? 'lisga act' : 'lisga'"> {{ item.name }}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  name: 'transRecord',
  data() {
    return {
      date: 4,
      list: [],
      pageData: {},
      type: 0,
      page: 1,
      dogameLis: [],
      api_type: '',
      loading: false,
      name: '', // 在 created 中赋值

      popup: false,
      showXuan: 1, //1平台选择 2 日期选择
      dropdownType: null, // 'type' or 'date'
    };
  },
  computed: {
    // 使用 computed 可以保证切换语言时这些数组能响应式更新
    dateName() {
      return ['', this.$t('Today'), this.$t('Last 7 Days'), this.$t('Last 15 Days'), this.$t('Last 30 Days')];
    },
    typeName() {
      return [
        this.$t('All'), this.$t('Deposit'), this.$t('Withdraw'), 
        this.$t('Transfer In'), this.$t('Transfer Out'), 
        this.$t('Transfer'), this.$t('Promotions'), this.$t('Commission')
      ];
    },
    stateType12() {
      return ['待上传凭证', this.$t('Pending Review'), this.$t('Approved'), this.$t('Rejected')];
    },
    stateType34() {
      return [this.$t('Failed'), this.$t('Success'), this.$t('Pending Settlement'), this.$t('Undefined')];
    }
  },
  created() {
    let that = this;
    const query = that.$route.query || {};
    if (query.type !== undefined && Number.isInteger(Number(query.type))) {
      that.type = Math.min(7, Math.max(0, Number(query.type)));
    }
    if (query.date !== undefined && Number.isInteger(Number(query.date))) {
      that.date = Math.min(4, Math.max(1, Number(query.date)));
    }
    that.name = that.$t('All Platforms');
    that.getdogame();
    that.getData();
  },
  methods: {
    canOpenDetail(item) {
      return !!(item && (item.can_detail == 1 || item.biz_type === 'recharge' || this.type === 1) && item.out_trade_no);
    },
    openDetail(item) {
      if (!this.canOpenDetail(item)) return;
      this.$router.push({ path: '/payInfo', query: { deposit_no: item.out_trade_no } });
    },
    stateText(item) {
      if (item.biz_type === 'recharge' || item.biz_type === 'withdraw' || this.type === 1 || this.type === 2) {
        return this.stateType12[item.state] || '-';
      }
      return this.stateType34[item.state] || '-';
    },
    showRefuseReason(item) {
      if (!item) return false;
      const isWithdraw = item.biz_type === 'withdraw' || this.type === 2;
      if (!isWithdraw || Number(item.state) !== 3) return false;
      return !!(item.refuse_reason || item.info);
    },
    refuseReasonText(item) {
      return (item && (item.refuse_reason || item.info)) || '';
    },
    changDogame(name, type) {
      let that = this;
      that.name = name;
      that.api_type = type;
      that.popup = false;
      that.page = 1;
      that.list = [];
      that.pageData = {};
      that.getData();
    },
    changtype(name, val) {
      let that = this;
      that[name] = val;
      that.popup = false;
      that.page = 1;
      that.list = [];
      that.pageData = {};
      that.getData();
    },
    showPopup(val) {
      this.popup = true;
      this.showXuan = val;
    },
    toggleDropdown(type) {
      if (this.dropdownType === type) {
        this.dropdownType = null;
      } else {
        this.dropdownType = type;
      }
    },
    selectType(index) {
      this.type = index;
      this.dropdownType = null;
      this.page = 1;
      this.list = [];
      this.pageData = {};
      this.getData();
    },
    selectDate(index) {
      this.date = index;
      this.dropdownType = null;
      this.page = 1;
      this.list = [];
      this.pageData = {};
      this.getData();
    },
    openOrclose() {
      this.show = !this.show;
    },
    changtab() {
      let that = this;
      that.page = 1;
      that.list = [];
      that.pageData = {};
      that.getData();
    },
    getdogame() {
      let that = this;
      that.$apiFun.post('/api/balancelist', {}).then(res => {
        if (res.code != 200) {
          that.showTost(res.message);
        }
        if (res.code == 200) {
          that.dogameLis = res.data;
          that.dogameLis.unshift({ name: that.$t('All Platforms'), platname: '' });
        }
      });
    },
    changeDate() {
      let that = this;
      that.page = 1;
      that.list = [];
      that.pageData = {};
      that.getData();
    },
    // 获取交易记录
    getData() {
      let that = this;
      let page = that.page;
      if (that.pageData.last_page && page > that.pageData.last_page) {
        that.loading = false;
        return;
      }
      that.$parent.showLoading();
      let info = {
        date: that.date,
        type: that.type,
        page: that.page,
        api_type: that.api_type,
      };
      that.$apiFun
        .post('/api/gettransrecord', info)
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.pageData = res.data || {};
            const rows = (res.data && res.data.data) || [];
            if (that.page == 1) {
              that.list = rows;
            } else {
              let list = JSON.parse(JSON.stringify(that.list));
              rows.forEach(el => {
                list.push(el);
              });
              that.list = list;
            }
            that.page = page + 1;
          }
          that.loading = false;
          that.$parent.hideLoading();
        })
        .catch(() => {
          that.$parent.hideLoading();
          that.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.saibox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 1.1rem;
  box-sizing: border-box;
  padding: 0 12px;
  border-bottom: 1px solid #e0e0e0;
  .sai {
    height: 1.1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 48%;
    font-size: 0.3rem;
    position: relative;
    color: #333;
    cursor: pointer;
    
    .truncate-text {
      max-width: 80%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    
    .arrow-down {
      display: inline-block;
      width: 0;
      height: 0;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 4px solid #333;
      margin-left: 5px;
      transition: transform 0.3s ease;
      &.active {
        transform: rotate(180deg);
      }
    }
  }
}

.lisg {
  box-sizing: border-box;
  padding: 15px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  background-color: #f5f5f5;
  .bs {
    width: 31%;
    height: 1.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    .lisga {
      width: 100%;
      height: 1.2rem;
      border: 1px solid #3d72fa;
      border-radius: 4px;
      color: #333;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.3rem;
      text-align: center;
      padding: 0 4px; /* 增加一点内边距防溢出 */
      line-height: 1.2;
    }
    .lisga.act {
      background: #3d72fa;
      color: #fff;
    }
  }
}

/* 下拉滚动选择框样式 */
.dropdown-container {
  position: relative;
  z-index: 1000;
  margin-top: 2px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  overflow: hidden;
  .dropdown-content {
    background-color: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    max-height: 200px;
    overflow-y: auto;
    .dropdown-grid {
      display: grid;
      /* 【修改点】：从4列改成3列，防止英文单词太长挤压变形 */
      grid-template-columns: repeat(3, 1fr);
      gap: 10px;
      padding: 10px;
      .dropdown-grid-item {
        padding: 8px 4px; /* 缩减左右padding腾出空间 */
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        text-align: center;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        &:hover {
          background-color: #f5f5f5;
        }
        div {
          font-size: 13px; /* 稍微缩小字号兼容英文 */
          color: #333;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          &.active {
            color: #3d72fa;
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/transRecord.vue